import { ajax } from '@/api/ajax'

//1、学生签到分页查询
export const reqSignList = (paramets) => ajax(`/jxclassroom/jxClassroomSign/getSignStuCountList`, paramets)

//2、学生签到通过id查询学生列表
export const reqSignById = (paramets) => ajax(`/jxclassroom/jxClassroomSignStu/getSignStuList`, paramets)

//3、学生签到通过id删除
export const reqSignDel = (paramets) => ajax(`/jxclassroom/jxClassroomSign/delete`, paramets, 'delete')

//4、学生签到状态修改
export const reqSignEdit = (paramets) => ajax(`/jxclassroom/jxClassroomSignStu/editStuSign`, paramets, 'post')

//5、学生签到信息导出
export const reqImportSign = (paramets) => ajax(`/jxclassroom/jxClassroomSign/exportXls`, paramets)


// WEBPACK FOOTER //
// ./src/api/kzActivity/sign.js